export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEEQjUtSGEMoUsA6k4OAOsvAQDrMQABgQICAYEGAgGBCgIBgQ4CAYESAgGBFgIBgRoCAYEeaADqTw==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/B5-V.bcmap
// module id = 614
// module chunks = 502